<template>
  <div>
    <div class="h-topo_pw2" v-show="see" :style="PositionXY">
      <div :style="topPannelStyle">
        <div class="h-topo_wytb_topwz" :title='k8sNodeName'>{{$t('Topo.devName')}}：{{k8sNodeName}}</div>
        <div :style="onOffButton">
          <span @click="click()" class="e-btn-icon icon hero-icon hero-icon-Expand" :title="$t('Common.close')"></span>
        </div>
      </div>
      <div :style="bottomPannelStyle" v-if="seeBottom">
        <div class="h-topo_wybox">
          <div class="h-topo_wytb3"></div>
          <div class="h-topo_wytb3" style="height: 30px">
            <span class="e-btn-icon icon hero-icon hero-icon-detailed"></span>
          </div>
          <div class="h-topo_xq">{{$t('Topo.serveDetail')}}</div>
          <!-- node数据面板 -->
          <div id="k8sNodePanelContent" style="overflow-y:scroll; width: 420px; height: 420px;" class="h-topo_content scroll">
            <ul id='service' class="h-topo_tableheight" >
              <li>{{$t('Topo.id')}}: {{k8sNodeId}}</li>
              <li>{{$t('Topo.ip')}}: {{k8sNodeIp}}</li>
              <li>{{$t('Topo.name')}}: {{k8sNodeName}}</li>
              <li>{{$t('Topo.memoryUsage')}}: {{k8sNodeMemoryUsage}}</li>
              <li>{{$t('Topo.cpuUsage')}}: {{k8sNodeCpuUsage}}</li>
              <!-- BEGIN POD -->
              <li v-if="k8sNode.length > 0">{{$t('Topo.servicePOD')}}:</li>
              <li v-if="k8sNode.length > 0">              
	              <ul id='pod' v-for="(pod, i) in k8sNode" >                 
						  <li>{{$t('Topo.id')}}: {{pod.id}}</li>
		                  <li>{{$t('Topo.nameSpace')}}: {{pod.namespace}}</li>
		                  <li>{{$t('Topo.name')}}: {{pod.name}}</li>
		                  <li>{{$t('Topo.runningStatus')}}: {{pod.status}}</li>
		                  <li>{{$t('Topo.ip')}}: {{pod.ip}}</li>
		                  <li  v-if="pod.children.length > 0" >{{$t('Topo.serviceContainer')}}:</li>
		                  <li  v-if="pod.children.length > 0" >
		                   	<ul id='containers' v-for="(containers, k) in pod.children">
			                      <li>{{$t('Topo.id')}}: {{containers.id}}</li>
			                      <li>{{$t('Topo.name')}}: {{containers.name}}</li>
			                      <li>{{$t('Topo.cpuUsage')}}: {{containers.cpuUsage}}</li>
			                      <li>{{$t('Topo.memoryUsage')}}: {{containers.memoryUsage}}</li>
			                      <li v-if="containers.children.length > 0" >{{$t('Topo.servicePID')}}:</li>
			                      <li v-if="containers.children.length > 0" >
			                        <ul id='four' v-for="(item, l) in containers.children" >
										<li>{{$t('Topo.id')}}: {{item.id}}</li>
										<li>{{$t('Topo.servicePID')}}: {{item.pid}}</li>
										<li>{{$t('Topo.dockerContainerId')}}: {{item.dockerContainerId}}</li>
										<li>{{$t('Topo.cpuUsage')}}: {{item.cpuUsage}}</li>
										<li>{{$t('Topo.memoryUsage')}}: {{item.memoryUsage}}</li>
										<li>{{$t('Topo.cmdline')}}: {{item.cmdline}}</li>
			                        </ul>
			                      </li>
		                    </ul>
		                 </li>
	                </ul>
              	</li>
              	<!-- /.END POD -->
            </ul>
          </div>
        </div>
        <div :style="alarmButton">
          <button class="e-primary e-btn" @click="alarmShowOperation">{{$t('Alarm.alarm')}}</button>
        </div>
      </div>
    </div>
    <!-- “告警弹窗展示” -->
    <CustomDialog ref="oprDialog" :element="oprSetDialog.element" :styles="oprSetDialog.styles">
      <template v-slot:dialog-content>
        <AlarmShowDialog ref='alarmDetailDialog'></AlarmShowDialog>
      </template>
    </CustomDialog>
  </div>
</template>
<script>
  import CustomDialog from "../../components/common/CustomDialog";
  import AlarmShowDialog from "../../components/topoconfig/AlarmShowDialog";
  import { EventBus } from '../../plugins/eventBus';
  import Table from "../deploymentManagement/serverManagement/Table";
  import {createNamespacedHelpers} from "vuex";
  const { mapGetters, mapActions } = createNamespacedHelpers('topoConfig');
  export default {
    name: "K8sNodePanel",
    components: {
      Table,
      CustomDialog,
      AlarmShowDialog
    },
    computed: {
      ...mapGetters(['physicalNodes', 'logicalNodes', 'getParentNe', 'getTypeByCode']),
    },
    data() {
      return {
        id: "",
        PositionXY: '',
        parentId: "",
        type: "",
        see: false,
        seeBottom: false,
        k8sNodeId: '',
        k8sNodeName: '',
        k8sNodeIp: '',
        k8sNodeMemoryUsage: '',
        k8sNodeCpuUsage: '',
        k8sNode: [], // k8s数据源
        alarmDetailObj: { id: this.id},
        typeCode: "",
        devInfo: {},
        space1: '&nbsp;&nbsp;',
        topPannelStyle: {
          width: '420px',
          height: '42px',
          background: '#000000',
          borderRadius: '5px',
          opacity: 0.70,
          boxShadow: '2px 2px 8px #4A5962',
        },
        onOffButton: {
          position: 'absolute',
          margin: '7px 365px',
          width: '10px',
          height: '10px',
          cursor: 'pointer',
        },
        bottomPannelStyle: {
          marginTop: '5px',
          width: '420px',
          height: '500px',
          background: '#000000',
          borderRadius: '5px',
          opacity: '0.70',
          boxShadow: '2px 2px 8px #4A5962',
          overflowY: 'auto',
        },
        serviceDetail: {
          position: 'absolute',
          /* marginLeft: '10px', */
          marginTop: '12px',
          color: '#DDDDDD',
          overflow: 'auto',
          overflowX: 'hidden',
          height: '420px',
          width: '420px',
          fontSize: '12px',
        },
        alarmButton: {
          position: 'absolute',
          marginTop: '460px',
          marginLeft: '330px',
        },

        oprSetDialog: {
          element: {
            title: this.$t("Alarm.alarm"),
            target: "#app",
            isClose: true,
            refName: "oprSetDia",
            buttonGroup: [
              {
                click: this.dialogHide,
                buttonModel: { content: this.$t("Topo.cancel") }
              }
            ]
          },
          styles: {
            width: "810px",
            height: "760px",
            model: true,
            visible: false,
          }
        }
      };
    },
    props: ["k8sNodeShow"],
    methods: {
      ...mapActions(['setPhysical', 'addPhysical', 'delPhysicalNodes']),
      panelBoardGetData() {
        let environmentId = 0;
        if (this.parentId) {
          environmentId = this.parentId;
        }
        const url = `/lte/ems/env/nodePanel?environmentId=${environmentId}&nodeId=${this.id}`;
        this.axios
          .get(url).then(response => {
          if (response && response.data.errorCode === "SUCCESS") {
            const result = response.data.resultVal;
            if (result && result.k8sNode) {
              const k8sNode = result.k8sNode;
              this.k8sNodeId = k8sNode.id;
              this.k8sNodeName = k8sNode.name;
              this.k8sNodeIp = k8sNode.ip;
              this.k8sNodeMemoryUsage = k8sNode.memoryUsage;
              this.k8sNodeCpuUsage = k8sNode.cpuUsage;
              this.k8sNode = k8sNode.children;
            }
          } else {
            this.k8sNodeId = '';
            this.k8sNodeName = '';
            this.k8sNodeIp = '';
            this.k8sNodeMemoryUsage = '';
            this.k8sNodeCpuUsage = '';
            this.k8sNode = '';
          }
        });
      },
      
      click() {
        this.seeBottom = !this.seeBottom;
        this.see = !this.see;
      },

      alarmShowOperation() {
	        const alarmId = this.id;
	        let ids = [alarmId];
	        this.$axios.get(`/lte/ems/topo/netElement/${alarmId}`).then(response => {
		          if (!response.data) {
		            return;
		          }
		          if (response && response.status === 200 && response.data.errorCode === "SUCCESS") {
		            if (response.data && response.data.resultVal.length > 0) {
		              ids = ids.concat(response.data.resultVal);
		            }
		          } 
		          else if(response.status === 401) {
		            EventBus.$emit('toast', {type: 'error', content: this.$t('System.loginAgain')});
		          } 
		          else {
		            EventBus.$emit('toast', {type: 'error', content: response.data.errorString});
		          }
		          this.$refs.alarmDetailDialog.beforeMount(ids);
		          this.$refs.oprDialog.show();
	        });
      },
      dialogHide() {
        this.$refs.oprDialog.clear();
        this.$refs.oprDialog.close();
      }
    },

    mounted() {},
    watch: {
      k8sNodeShow: {
        handler: function(newVal, oldVal) {
        
	         this.see = newVal.seeObj;
	         this.seeBottom = newVal.seeBottomObj;
	         this.id = newVal.idObj;
	         this.type = newVal.typeObj;
	         this.parentId = newVal.parentId;
	         if (newVal.onlineObj === 1) {
	            this.online='h-pm-iconOnline';
	         } 
	         else if(newVal.onlineObj === 0) {
	            this.online='h-pm-iconOffline';
	         }
          
          	 this.PositionXY = newVal.PositionXY; //-- panel position
          	 this.panelBoardGetData(); // 请求后台查询信息
          	
          	 if(document.getElementById("k8sNodePanelContent") != null)
          		document.getElementById("k8sNodePanelContent").scrollTop = 0; 	//-- scroll to top  
	          
        },
        deep: true
      }
    }
  };
</script>
<style>
</style>
